import { render } from "./DepositRequestApproved.vue?vue&type=template&id=52d1c778"
import script from "./DepositRequestApproved.vue?vue&type=script&lang=js"
export * from "./DepositRequestApproved.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__